export default __webpack_public_path__ + "static/media/stam.898abe0b.png";